import { serverNow } from '../services/serverClock';

/**
 * Server-time stamp for export filenames: `YYYY-MM-DD_HH-mm-ss`.
 *
 * Defaults to the SERVER clock (via serverNow(), derived from the HTTP `Date`
 * header captured in baseQuery) so a user who changes their machine clock can't
 * change the stamp on downloads. Falls back to the local clock until the first
 * API response has been seen. Still built from the local date getters on the
 * (offset-corrected) Date so the stamp reads in the user's timezone.
 */
export const exportTimestamp = (date: Date = serverNow()): string => {
  const p = (n: number) => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}` +
    `_${p(date.getHours())}-${p(date.getMinutes())}-${p(date.getSeconds())}`
  );
};

/**
 * Human-readable "Exported on …" caption stamped INSIDE an export (chart PDF
 * footer, PNG/JPG footer strip, and the header line in the grid
 * PDF / CSV / Excel bodies).
 *
 * Also defaults to SERVER time (serverNow()). Uses en-GB local formatting
 * (day/month/year + 24h clock) to match the existing grid exports.
 */
export const exportedOnText = (date: Date = serverNow()): string =>
  `Exported on ${date.toLocaleString('en-GB')}`;

export default exportTimestamp;
